












































import { Component, Prop } from 'vue-property-decorator'

import { UseFields } from '../../../../../../../../../Pi'
import { FieldData } from '../../../../../../../../../Pi/types'
import {
  ProxyDelayIntervalType,
  ProxyDelayPropertyType,
} from '../../../logic/Proxy/ProxyDelayTypes'

@Component
export default class DelayLimit extends UseFields {
  @Prop() delay!: ProxyDelayIntervalType | ProxyDelayPropertyType

  setLimitTimeFrom(arg: FieldData): FieldData {
    arg.setter = (val) => this.delay.setLimitFrom(val)
    return arg
  }

  setLimitTimeTo(arg: FieldData): FieldData {
    arg.setter = (val) => this.delay.setLimitTo(val)
    return arg
  }

  setDaysOfWeek(arg: FieldData): FieldData {
    arg.setter = (val) => this.delay.setLimitDaysOfWeek(val)
    return arg
  }
}
